import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { useAuth } from "../lib/auth";
import { isPageAvailable, unavailableMessage } from "../lib/lifecycle";

/**
 * Wraps a seller page that only applies at certain listing stages.
 *
 * The nav already hides these, but bookmarks, old emails, and the browser's
 * back button don't care about the nav. Rather than redirecting — which looks
 * like a bug when you tap a link you saved — this explains why the page isn't
 * there and points somewhere useful.
 *
 * Agents are never gated: they need to see every page to support their sellers,
 * and impersonation swaps in the seller's own record anyway.
 */
export default function StageRoute({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (!user || user.role === "admin") return children;
  if (isPageAvailable(pathname, user.lifecycle_status)) return children;

  const { title, body } = unavailableMessage(pathname, user.lifecycle_status);

  return (
    <div className="container-x" style={{ padding: "64px 0 80px" }} data-testid="stage-gate">
      <div className="card" style={{ padding: 40, maxWidth: 520, margin: "0 auto", textAlign: "center" }}>
        <div
          style={{
            width: 52, height: 52, borderRadius: "50%", margin: "0 auto 20px",
            background: "var(--surface-alt)", display: "flex",
            alignItems: "center", justifyContent: "center",
          }}
        >
          <CalendarClock size={22} style={{ color: "var(--primary)" }} />
        </div>
        <h1 className="font-serif" style={{ fontSize: 26, fontWeight: 500, margin: "0 0 10px" }}>
          {title}
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: 15, lineHeight: 1.65, margin: "0 0 26px" }}>
          {body}
        </p>
        <Link to="/dashboard" className="btn-primary" style={{ textDecoration: "none" }}>
          Back to your dashboard
        </Link>
      </div>
    </div>
  );
}
